module.exports = __webpack_public_path__ + "static/media/293846.53b4a16b.png";